export default "__VITE_ASSET__cc73762b__"